import getHeight from '../../core/getElementHeight';

export default () => {
  const shoppableModal = document.querySelector('[data-shoppable-image-modal]');
  const preHeader = document.querySelector('[data-pre-header]');
  const header = document.querySelector('[data-header]');
  const calculateHeight = () => {
    return window.innerHeight - getHeight([preHeader, header]);
  };
  if (shoppableModal) {
    shoppableModal.style.height = `${calculateHeight()}px`;
    shoppableModal.style.top = `${getHeight([preHeader, header])}px`;
  }
  if (window.theme.breakpoints.current === 'mobile') {
    const mobileHeight = window.innerHeight - getHeight([header]);
    if (shoppableModal) {
      shoppableModal.style.height = `${mobileHeight}px`;
      shoppableModal.style.top = `${getHeight([header])}px`;
    }
  }
};
